<h4  class="dialogHeadlineGenerique" mat-dialog-title>Are you sure, you want to delete this page ?</h4>
<mat-dialog-actions flex-center>
    <button (click)="deletePageInf()" type="button" class="btn  btn-secondaryWithBorderDialog shadow-none mr10"> <b>YES</b> </button>
    <button type="button" class=" btn btn-secondaryWithBorder shadow-none ml-4" mat-dialog-close> <b>No</b> </button>
</mat-dialog-actions>
